const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar',
            close:              'Close',
            childs:             'Submenus',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            empty_error:        'Problema ao actualizar registo, campos vazios!',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            link:               'Link',
            link_placeholder:   'Introduza o link',
            menu:               'Menu',
            menu_edit:           'Editar menu',
            menu_new:           'Novo menu',
            menu_config:        'Configuração do menu',
            menu_list:          'Lista de menus',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao actualizar registo!',
            insert_success:     'Registo actualizado com sucesso!',
            pages:              'Páginas',
            principal:          'Principal',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            save:               'Salvar',
            structure:          'Estrutura',
            title:              'Título',
            type:               'Tipo',
            type_horizontal:    'Horizontal',
            type_vertical:      'Vertical',                    
        },
    'en':
        {
            add_new:            'Add new',
            cancel:             'Cancel',
            childs:             'Childs',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',  
            edit:               'Edit',              
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',  
            empty_error:        'Problem updating element, empty fields!',          
            filter_placeholder: 'Search',
            id:                 'ID',
            link:               'Link',
            link_placeholder:   'Introduza o link',
            menu:               'Menu',
            menu_edit:          'Edit menu',
            menu_new:           'New menu',
            menu_config:        'Menu Configuration',
            menu_list:          'Menus List',
            name:               'Name',
            name_placeholder:   'Insert the name',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',            
            pages:              'Pages',
            principal:          'Principal',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            save:               'Save',
            structure:          'Structure',
            title:              'Title',
            type:               'Type',
            type_horizontal:    'Horizontal',
            type_vertical:      'Vertical',
        }
}

module.exports = {
    language
};